import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,getDataPlan,setDataPlan } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import PoppinsRegularBase64 from '../fonts/Poppins-Regular.js';
import PoppinsBoldBase64 from '../fonts/Poppins-Bold.js';
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import "../stili/planning.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs'
import {
    convertiIdInventario,
    sovrapposti,
    convertiTipoStorage,
    convertiIdNoleggio,
    getLinguaMessaggio,
    getIDLingua,
    ordinaPerData,
    prendiNomePacchetto,
    coloreDaId,
    pacchettiAperti,
    materialeDisponibile,
    istruttori_disponibili,
    isoToString,
    totaleCosti, convertiCambi, guadagnoEscursione
} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers,faCircleInfo,faSpinner, faUser, faBox, faCheck, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
import { RRule, rrulestr } from 'rrule';
import meteo from "../funzioni/previsionimeteo"
/* global $ */
export default function DashboardOggi() {
    let dettagli={}
    let spese={}
    let utenti=[]
    const listinoPrezziNol = {
  1: { // Attrezzatura completa
    nome: "Attrezzatura completa",
    prezzi: { 1: 70,2:140 ,3: 210, 4:270,5: 330,6:360, 7: 385 }
  },
  2: { // Kite e barra
    nome: "Kite e barra",
    prezzi: { 1: 50, 2:100, 3: 105, 4:135, 5: 165, 7: 190 }
  },
  3: { // Tavola twin tip
    nome: "Tavola twin tip",
    prezzi: { 1: 40, 2:80, 3: 105,4:135, 5: 165, 7: 190 }
  },
  4: { // Tavola surfino
    nome: "Tavola surfino",
    prezzi: { 1: 45,2:90, 3: 130,4:165, 5: 200, 7: 230 }
  },
  5: { // Tavola foil
    nome: "Tavola foil",
    prezzi: { 1: 45,2:90, 3: 130,4:165, 5: 200, 7: 230 }
  },
  6: { // Harness
    nome: "Harness",
    prezzi: { 1: 10 }
  },
  7: { // Lycra e muta
    nome: "Lycra e muta",
    prezzi: { 1: 10 }
  },
  8: { // Caschetto e giubbotto
    nome: "Caschetto e giubbotto",
    prezzi: { 1: 10 }
  },
  9: { // Twin tip - Surfino
    nome: "Twin tip - Surfino",
    prezzi: {}
  },
  10: { // Material Insurance
    nome: "Material Insurance",
    prezzi: { 1: 10, 7: 50 }
  }
}
function DynamicLessonButton({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);
          const content = await mostraPopupInfoLezione(
            parseInt(cellInfo.data.id),cellInfo.data.nome
          );

          $("#loadingOverlay").hide();  // Nasconde overlay
            setLoading(false);
          $("#infoPopup").dxPopup("instance").option(
            "title",
            `Dettagli lezioni di ${cellInfo.data.nome}`
          );
          $("#infoPopup").dxPopup("instance").option("contentTemplate", () => content);
          $("#infoPopup").dxPopup("instance").show();
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faCircleInfo}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function riempiPopup(tipo){
    const divGen=document.createElement("div")
    const divLezioni=document.createElement("div")
    divLezioni.id="gridContainerDetLez"
    if (tipo==="lezioni") divGen.appendChild(divLezioni)
    const divNol=document.createElement("div")
    divNol.id="gridContainerDetNol"
    const divStorage=document.createElement("div")
    divStorage.id="gridContainerDetStor"
    const divEsc=document.createElement("div")
    divEsc.id="gridContainerDetEsc"
    const divMaglie=document.createElement("div")
    divMaglie.id="gridContainerDetMaglie"
    const divRip=document.createElement("div")
    divRip.id="gridContainerDetRip"
    if (tipo==="lezioni") divGen.appendChild(divLezioni)
    else  if (tipo==="noleggi") divGen.appendChild(divNol)
    else if (tipo==="storage") divGen.appendChild(divStorage)
    else if (tipo==="escursioni") divGen.appendChild(divEsc)
    else if  (tipo==="maglie") divGen.appendChild(divMaglie)
    else  divGen.appendChild(divRip)
    setTimeout(()=>{
        $("#gridContainerDetNol").dxDataGrid({
    width:"100%",
    dataSource:dettagli["noleggi"],
    columns:[
    {dataField:"rentalid",caption:"Cliente",groupIndex:0,alignment:"center",groupCellTemplate: function (cellElement, cellInfo) {
    const id = cellInfo.value;
    const dataSource = $("#gridContainerDetNol").dxDataGrid("instance").option("dataSource");
    let nome =null
            let costoTot=0
    for (let nol of dataSource){
        if (nol.rentalid===id){
            nome=nol.nome
            costoTot+=nol.costo
        }
    }
    cellElement.text(`${nome}: tot ${costoTot.toFixed(2)} €`);
  }},
    {dataField:"durata",caption:"Durata noleggio",hidingPriority:3, customizeText:function(e){
        return differenzaOrario({dataInizio:e.value})
        }},
        {dataField:"materiale",caption:"Materile noleggiato", hidingPriority:2},
        {dataField:"tipo",caption:"Tipo Noleggio", customizeText(e){
            return convertiIdNoleggio(e.value)
            } },
        {dataField:"costo",caption:"Costo noleggio", customizeText:function(e){return `${e.value.toFixed(2)} €`}},
        {dataField:"nomeNol",caption:"noleggiato da", hidingPriority:1},

    ],
columnAutoWidth: true,
      height: "auto",
      columnHidingEnabled: true,
    })
      $("#gridContainerDetLez").dxDataGrid({
    width:"100%",
    dataSource:dettagli["lezioni"],
    columns:[
    {dataField:"studente",caption:"Nome studente",alignment:"center",hidingPriority: 5},
    {dataField:"durata",caption:"Durata Lezione",hidingPriority:3, customizeText:function(e){
        return differenzaOrario({dataInizio:e.value*3600*1000})
        }},
        {dataField:"istruttore",caption:"Istruttore", hidingPriority:2,customizeText:function(e){
            return nome_id({id:e.value,utenti:utenti})
            }},
        {dataField:"commissione",caption:"Commissione istruttore", hidingPriority: 1,customizeText(e){
            return `${e.value.toFixed(2)} €`
            } },
        {dataField:"guadagno",caption:"Guadagno lezione",hidingPriority: 4, customizeText:function(e){return `${e.value.toFixed(2)} €`}},

    ],
columnAutoWidth: true,
      height: "auto",
      columnHidingEnabled: true,
    })
        $("#gridContainerDetStor").dxDataGrid({
    width:"100%",
    dataSource:dettagli["storage"],
    columns:[
    {dataField:"storagecustname",caption:"Nome",alignment:"center",hidingPriority: 4},
    {dataField:"storagecost",caption:"Costo",hidingPriority:3, calculateDisplayValue: function(rowData){
        return `${((1 - rowData.storagediscount / 100) * rowData.storagecost).toFixed(2)} €`
        }},
        {dataField:"storagefrom",caption:"Storage Da", hidingPriority:2,calculateDisplayValue: function(rowData){
            return DateTime.fromFormat(rowData.storagefrom,"yyyyMMdd").toFormat("dd/MM/yyyy")
            }},
        {dataField:"storageto",caption:"Storage A", hidingPriority: 1,calculateDisplayValue: function(rowData){
            return DateTime.fromFormat(rowData.storageto,"yyyyMMdd").toFormat("dd/MM/yyyy")
            } },

    ],
columnAutoWidth: true,
      height: "auto",
      columnHidingEnabled: true,
    })

    },0)
    return divGen

}
function apriPopupDettagli(tipo){
$("#infoDettagli").dxPopup("instance").option(
            "title",
            `Dettagli ${tipo}`
          );
const content=riempiPopup(tipo)
$("#infoDettagli").dxPopup("instance").option("contentTemplate", () => content);
$("#infoDettagli").dxPopup("instance").show();
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
async function mostraPopupInfoLezione(id,nome) {
  const allineamento="center"
  const lez_pac_gen = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
    filtri: {"lessondatesfrom":DateTime.fromJSDate(selectedDate).toFormat("yyyyMMdd"),"lessondatesto":DateTime.fromJSDate(selectedDate).plus({days:1}).toFormat("yyyyMMdd")},
  });
  let lez_pac=[]
  let lez_pach_prog=[]
  for (let i of lez_pac_gen){
    if (i.userid===id){
        lez_pac.push(i)
    }
  }
   utenti = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:'getUsers'
  });
  const formattedRows2 = lez_pac.map((row, index) => ({
    id: index,
    lessondateid:row.lessondateid,
    inizio: convertDate(row.lessondatestart).toISO({ includeOffset: false }),
    fine: convertDate(row.lessondateend).toISO({ includeOffset: false }),
    durata: convertDate(row.lessondateend)-convertDate(row.lessondatestart),
    istruttore: nome_id({id:row.userid, utenti:utenti}),
  }));
  const div = document.createElement("div");
  div.style.padding = "0px";
  const titolo1=document.createElement("h3")
  titolo1.innerText="Ore concluse"
  titolo1.style.fontFamily = "Poppins, sans-serif";
  titolo1.style.marginBottom="0px"
  const inner = document.createElement("div");
  inner.id = "gridContainerSecond";
  div.appendChild(inner);
  const titolo2=document.createElement("h3")

  titolo2.innerText="Ore Programmate"
  titolo2.style.fontFamily = "Poppins, sans-serif";
  titolo2.style.marginBottom="0px"
  if (lez_pach_prog.length!==0)
  div.appendChild(titolo2)
  if (lez_pach_prog.length!==0){
  const inner2=document.createElement("div");
  inner2.id = "gridContainerSecondProg";

  div.appendChild(inner2);}
  const commento = document.createElement("p");
  let totale_ore=0
  let totale_ore_prog=0
  for (let i of lez_pac) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs}
  for (let i of lez_pach_prog) {const diffMs = convertDate(i.lessondateend)-convertDate(i.lessondatestart);
  totale_ore+=diffMs
  totale_ore_prog+=diffMs}
  if (totale_ore_prog===0)
  commento.innerText = `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}`
  else commento.innerText = `Ore totali di ${nome}: ${differenzaOrario({dataInizio:totale_ore})}, di cui ${differenzaOrario({dataInizio:totale_ore-totale_ore_prog})} concluse e ${differenzaOrario({dataInizio:totale_ore_prog})} programmate`
  commento.style.marginTop = "10px";
  commento.style.fontWeight = "bold";
  commento.style.fontSize = "24px";
  commento.style.fontFamily = "Poppins, sans-serif";
  div.appendChild(commento);
  setTimeout(() => {
    $("#gridContainerSecond").dxDataGrid({
      dataSource: formattedRows2,
      columns: [
        {
          dataField: "inizio",
          caption: "Data e ora inizio",
          hidingPriority:5,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
        },
        { dataField: "fine", alignment:allineamento,caption: "Data e ora fine", hidingPriority:4,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          }, editorType: 'dxDateBox',
            editorOptions: {
            displayFormat: "dd/MM/yyyy",
  },},
        { dataField: "durata", alignment:allineamento,caption: "Durata lezione",hidingPriority:6,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
        },
        { dataField: "istruttore",alignment:allineamento, caption: "Istruttore" ,hidingPriority:3,
        },

      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica lezione di ${nome}`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","durata","istruttore","status",
                ],
              },
              {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: ["livello"
                ],
              },
            ],
          },
          },
    onCellClick: function(e) {
                if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {

      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
      if (!($icon.length)) {
      const masterRow = e.component.getRowElement(e.row.rowIndex);
      const $icon = masterRow.find(".dx-datagrid-adaptive-more");
      if ($icon.length){
      $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
      }
      else
      {
      $icon[0].className = "dx-datagrid-adaptive-more";
      }}

    },

    });

  }, 0);

  return div;
}
const today = new Date();
today.setHours(0, 0, 0, 0)
    const [selectedDate, setSelectedDate] = useState(today);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
   const [datiOggi, setDatiOggi] = useState([null, null, null]); // placeholder iniziale
  const [loading, setLoading] = useState(true);
  const [appOggi, setAppOggi] = useState({Noleggi:[],Lezioni:[],Storage:[]});

let peoplePerDay = {
};

// Funzione che restituisce un colore in base al numero
function getColorByPeople(count) {
  if (count >= 10) return "rgba(255, 99, 132, 0.25)";   // rosso tenue
  if (count >= 5) return "rgba(255, 206, 86, 0.25)";    // giallo chiaro
  if (count > 0 ) return "rgba(75, 192, 192, 0.25)";
  return "";
}

function getCellTemplate(data) {
  let bgColor = "";
  if (data.view === "month" && data.date) {
    const key = data.date.getFullYear() + "-" +
            String(data.date.getMonth() + 1).padStart(2, "0") + "-" +
            String(data.date.getDate()).padStart(2, "0");
    const peopleCount = peoplePerDay[key] || 0;
    bgColor = getColorByPeople(peopleCount);
  }

  // Applica il colore se presente
  const style = bgColor
    ? `background-color:${bgColor};color:black`
    : "";

  return `<span style='${style}'>${data.text}</span>`;
}
  useEffect(() => {
    $("#gridContainerAll").dxDataGrid({
    width:"100%",
    dataSource:[],
    columns:[
    {dataField:"confermata",caption:"Confermata",groupIndex:0,alignment:"center",customizeText:function(e){if (e.value===1) return "Si"
    else return "No"
    }},
    {dataField:"tipo",caption:"Tipo Servizio",groupIndex:1},
    {dataField:"nome",caption:""}
    ],
    })
    const tip={1:'Lezione confermata',2:'Lezione non confermata',3:'Noleggio confermato',4:'Noleggio non confermato',5:'Storage confermato',6:'Storage non confermato',}
    const types = [{
  text: 'Lezione confermata',
  id: 1,
  color: '#0096C7',
}, {
  text: 'Lezione non confermata',
  id: 2,
  color: '#ADE8F4',
}, {
  text: 'Noleggio confermato',
  id: 3,
  color: '#00B894',
}, {
  text: 'Noleggio non confermato',
  id: 4,
  color: '#A8E6CF',
},
{
  text: 'Storage confermato',
  id: 5,
  color: '#FFA45B',
},
{
  text: 'Storage non confermato',
  id: 6,
  color: '#FFD6A5',
},
];

    $('#schedulerArrivi').dxScheduler({
    views: ['agenda'],
    dataSource:[],
    currentView: 'agenda',
    appointmentTemplate: function (modelData) {
    const { appointmentData, targetedAppointmentData } = modelData;

    // Contenitore principale orizzontale (cerchio + testo)
    const $container = $("<div>")
      .css({
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        height:"120px"
      });

    // Cerchio colorato
    const $marker = $("<div>")
      .addClass("dx-scheduler-agenda-appointment-marker")
      .css({
        background: targetedAppointmentData.color || "#0072ff",
        marginTop: "4px",
      });

    // Contenitore testo (verticale)
    const $textBlock = $("<div>")
      .css({
        display: "flex",
        flexDirection: "column",
        lineHeight: "1.4",
      });

    // Riga 1: Nome
    const $name = $("<div>")
      .addClass("dx-scheduler-agenda-appointment-content")
      .text(appointmentData.nome || appointmentData.text)
      .css({
        fontFamily:"Poppins, sans-serif",
        fontWeight: 600,
        fontSize: "14px",
      });

    // Riga 2: Tipo
    const $tipo = $("<div>")
      .text(`Periodo: ${DateTime.fromFormat(appointmentData.inizio,"yyyyMMdd").toFormat("dd/MM")} - ${DateTime.fromFormat(appointmentData.fine,"yyyyMMdd").toFormat("dd/MM")}. ${tip[appointmentData.assigneeId]}`)
      .css({fontFamily:"Poppins, sans-serif",
        fontSize: "12px",
        opacity: 0.8,
      });
    $textBlock.append($name, $tipo, );
    $container.append($marker, $textBlock);
    return $container;
  },
    resources: [
      {
        fieldExpr: 'assigneeId',
        allowMultiple: true,
        dataSource: types,
        label: 'Tipo di seervizio',
        useColorAsDefault: true,}],
  });
    $("#infoPopup").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    hideOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    const $scroll = $("#customScroll");

    if ($scroll.length) {
        if ($scroll.data("dxScrollView")) {
            $scroll.dxScrollView("instance").dispose();
        }
        $scroll.remove();
    }

    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}

});
    function handleResize() {
      setIsMobile(window.innerWidth < 600);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(()=>{
  $("#gridContainerOre").dxDataGrid({
    dataSource:[],
    columnAutoWidth: true,
      columnHidingEnabled: true,
    columns:[
    {dataField:"nome","caption":"Istruttore",alignment:"center",hidingPriority:3},
    {dataField:"disponibili","caption":"Ore Totali",hidingPriority:1,alignment:"center",customizeText:function(e){return `${e.value.toFixed(1)}H`}},
    {dataField:"prenotate","caption":"Ore Prenotate",hidingPriority:2,alignment:"center",customizeText:function(e){return `${e.value.toFixed(1)}H`}},
    {dataField:"libere","caption":"Ore Libere",hidingPriority:4,alignment:"center",customizeText:function(e){return `${e.value.toFixed(1)}H`}},
    {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
  hint: "Dettagli lezioni",
  icon: "none",
  template: function (cellElement, cellInfo) {
    const root = ReactDOM.createRoot(cellElement.get(0));
    root.render(<DynamicLessonButton cellInfo={cellInfo} />);
  },
},]}
    ],
  })

$("#dateboxRef").dxDateBox({
    label:"Seleziona data plan",
        value: selectedDate,
      displayFormat: "dd/MM/yyyy",
      openOnFieldClick: true,
      pickerType: "calendar",
      onOpened: function (e) {
    const calendar = e.component._popup.$content().find(".dx-calendar").dxCalendar("instance");
    calendar.option("cellTemplate", getCellTemplate);
  },
      onValueChanged: function(e) {
        const d = e.value;
  const dateOnly = new Date(d.getFullYear(), d.getMonth(), d.getDate()); // forza 00:00:00
  setSelectedDate(dateOnly);
      },
    })

        async function fetchData() {
       let guadagni={lezioni:0,noleggi:0,storage:0,escursioni:0,riparazioni:0,maglie:0}
        setLoading(true)
        peoplePerDay={}
        let [
  response,
  responseR,
  responseS,
  ore,
  utenti2,
  periodi,
  datiCambi,
  accessori,
  riparazioni,
            escursioni,clientiEsc,costiEsc,

] = await Promise.all([

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    filtri: { lessondatestatus: 2 },
    azione: 'getLessons'
  }),

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione: 'getRentals'
  }),

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione: 'getStorages'
  }),

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    filtri: {
      lessondatesfrom: DateTime.fromJSDate(selectedDate).toFormat("yyyyMMdd"),
      lessondatesto: DateTime.fromJSDate(selectedDate).plus({ days: 1 }).toFormat("yyyyMMdd")
    },
      childs:["inventories"],
    azione: 'getLessonDates'
  }),

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione: 'getUsers'
  }),

  funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione: 'getUserWorkPeriods'
  }),
            funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExchanges",
                filtri:{"exchangefrom":DateTime.fromJSDate(selectedDate).toFormat("yyyyMMdd"),"exchangeto":DateTime.fromJSDate(selectedDate).plus({ days: 2 }).toFormat("yyyyMMdd"),"exchangerates":"USDEUR"+","+"USDKES"},
                }),
            funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getAccessoryItems",
                }),
            funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRepairs",
                filtri: {
      repairsfrom: DateTime.fromJSDate(selectedDate).toFormat("yyyyMMdd"),
      repairsto: DateTime.fromJSDate(selectedDate).plus({ days: 1 }).toFormat("yyyyMMdd")
    },
                }),
            funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursions",
                filtri: {
      excursionsfrom: DateTime.fromJSDate(selectedDate).minus({days:1}).toFormat("yyyyMMdd"),
      excursionsto: DateTime.fromJSDate(selectedDate).plus({ days: 1 }).toFormat("yyyyMMdd")
    },
            }),

            funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCusts",
            }),
            funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        azione: "getExcursionCosts",
    }),




]);
        datiCambi=convertiCambi(datiCambi,["EURKES"])
            utenti=utenti2
      const oreIstruttori={}
      for (let periodo of periodi){
        const dataL=DateTime.fromJSDate(selectedDate)
        if (DateTime.fromFormat(periodo.workperioddatefrom,"yyyyMMdd")<=dataL &&dataL<=DateTime.fromFormat(periodo.workperioddateto,"yyyyMMdd")){
            for (let utente of utenti){
                if (utente.userid===periodo.userid){
                    if ([1,2,5].includes(utente.type)){
                        oreIstruttori[utente.userid]={"disponibili":5.5,"prenotate":0,"nome":`${utente.name} ${utente.surname}`}
                    }
                }
            }
        }
      }
      for (let ora of ore){
        oreIstruttori[ora.userid]["prenotate"]+=((convertDate(ora.lessondateend)-convertDate(ora.lessondatestart))/(60*60*1000))
      }
      let dataSourceTabOre=[]
      for (let id in oreIstruttori){
        dataSourceTabOre.push({"id":id,"libere":oreIstruttori[id]["disponibili"]-oreIstruttori[id]["prenotate"],"nome":oreIstruttori[id]["nome"],"disponibili":oreIstruttori[id]["disponibili"],"prenotate":oreIstruttori[id]["prenotate"]})

      }
      $("#gridContainerOre").dxDataGrid("instance").option("dataSource",dataSourceTabOre)
        let data=[]
        let confermate=0
        let nConf=0
        let lez = [];
        let nol = [];
        let sto = [];
        dettagli={}
        let dataSourceSched=[]
        let contatore=1
        for (let lezione of response){
            const dataL=DateTime.fromJSDate(selectedDate)
            const listaNo=lezione.lessonclientunavailable?lezione.lessonclientunavailable.split(","):[]
            if (lezione.lessonclientarrival && lezione.lessonclientdeparture &&!(listaNo.includes(dataL.toFormat("yyyyMMdd"))) && DateTime.fromFormat(lezione.lessonclientarrival,"yyyyMMdd")<=dataL &&dataL<=DateTime.fromFormat(lezione.lessonclientdeparture,"yyyyMMdd")){
                if (lezione.lessonconfirmed){
                    confermate+=1
                    lez.push(lezione)
                }
                else{
                    lez.push(lezione)
                    nConf+=1
                }
            }
            if (lezione.lessonclientarrival&&lezione.lessonclientdeparture)
            dataSourceSched.push({id: contatore,
  text: lezione.lessonstudentname,
  startDate: new Date(convertDate(lezione.lessonclientarrival).toISO({ includeOffset: false })+"Z"),
  endDate: new Date(convertDate(lezione.lessonclientarrival).toISO({ includeOffset: false })+"Z"),
  inizio:lezione.lessonclientarrival,
  fine:lezione.lessonclientdeparture,
  assigneeId: lezione.lessonconfirmed?1:2,})
  contatore++
        }
        data.push({"categoria":"Lezioni","confermate":confermate, "nonConfermate":nConf})
        confermate=0
        nConf=0
        for (let noleggio of responseR){
            const dataL=DateTime.fromJSDate(selectedDate)
            const listaNo=noleggio.rentalcustunavailable?noleggio.rentalcustunavailable.split(","):[]
            if (noleggio.rentalfrom && noleggio.rentalto && !(listaNo.includes(dataL.toFormat("yyyyMMdd"))) && DateTime.fromFormat(noleggio.rentalfrom,"yyyyMMdd")<=dataL &&dataL<=DateTime.fromFormat(noleggio.rentalto,"yyyyMMdd")){
               if (noleggio.rentalconfirmed){
                    confermate+=1
                    nol.push(noleggio)
                }
                else{
                nol.push(noleggio)
                    nConf+=1
                }
            }
            if (noleggio.rentalfrom&&noleggio.rentalto)
            dataSourceSched.push({id: contatore,
  text: noleggio.rentalcustname,
  startDate: new Date(convertDate(noleggio.rentalfrom).toISO({ includeOffset: false })+"Z"),
  endDate: new Date(convertDate(noleggio.rentalfrom).toISO({ includeOffset: false })+"Z"),
  inizio:noleggio.rentalfrom,
  fine:noleggio.rentalto,
  assigneeId: noleggio.rentalconfirmed?3:4,})
  contatore++
        }
        data.push({"categoria":"Noleggi","confermate":confermate, "nonConfermate":nConf})
        confermate=0
        nConf=0
        for (let storage of responseS){
            const dataL=DateTime.fromJSDate(selectedDate)
            if (storage.storagefrom && storage.storageto && DateTime.fromFormat(storage.storagefrom,"yyyyMMdd")<=dataL &&dataL<=DateTime.fromFormat(storage.storageto,"yyyyMMdd")){
                if (storage.storageconfirmed){
                sto.push(storage)
                    confermate+=1
                }
                else{
                sto.push(storage)
                    nConf+=1
                }
            }
            if (storage.storagefrom&&storage.storageto)
            dataSourceSched.push({id: contatore,
  text: storage.storagecustname,
  startDate: new Date(convertDate(storage.storagefrom).toISO({ includeOffset: false })+"Z"),
  endDate: new Date(convertDate(storage.storagefrom).toISO({ includeOffset: false })+"Z"),
  inizio:storage.storagefrom,
  fine:storage.storageto,
  assigneeId: storage.storageconfirmed==0?6:5,})
  contatore++
        }
        data.push({"categoria":"Storage","confermate":confermate, "nonConfermate":nConf})
        // data deve essere un array simile a:
        // [{ categoria: "Lezioni", confermate: 8, nonConfermate: 3 }, ...]
         let dataSourTab=[]
         const totAp={Noleggi:nol,Lezioni:lez,Storage:sto}
         for (let tipo in totAp){
            for (let appuntamento of totAp[tipo]){
                if (tipo==="Lezioni")
                dataSourTab.push({"tipo":tipo,confermata:appuntamento.lessonconfirmed,nome:appuntamento.lessonstudentname})
                else if (tipo==="Noleggi"){
                    dataSourTab.push({"tipo":tipo,confermata:appuntamento.rentalconfirmed,nome:appuntamento.rentalcustname})
                }
                else dataSourTab.push({"tipo":tipo,confermata:appuntamento.storageconfirmed===null?1:appuntamento.storageconfirmed,nome:appuntamento.storagecustname})
            }
         }
         $("#gridContainerAll").dxDataGrid("instance").option("dataSource",dataSourTab)
         $("#schedulerArrivi").dxScheduler("instance").option("dataSource",dataSourceSched)
         setAppOggi(totAp);

         let oggi = DateTime.fromJSDate(selectedDate);
    const start = oggi.minus({ days: 20 });
    const end = oggi.plus({ days: 20 })
    const lezFilt= response.filter(lezione => {
      if (!lezione.lessonclientarrival || !lezione.lessonclientdeparture) return false;
      const from = DateTime.fromFormat(lezione.lessonclientarrival, "yyyyMMdd");
      const to = DateTime.fromFormat(lezione.lessonclientdeparture, "yyyyMMdd");

      return to >= start && from <= end;
    });
    const nolFilt= responseR.filter(lezione => {
      if (!lezione.rentalfrom || !lezione.rentalto) return false;
      const from = DateTime.fromFormat(lezione.rentalfrom, "yyyyMMdd");
      const to = DateTime.fromFormat(lezione.rentalto, "yyyyMMdd");
      return to >= start && from <= end;
    });
    lezFilt.forEach(lezione => {
      const from = DateTime.fromFormat(lezione.lessonclientarrival, "yyyyMMdd");
      const to = DateTime.fromFormat(lezione.lessonclientdeparture, "yyyyMMdd");
      let d=from

      while (d <= to){
        const key = d.toFormat("yyyy-MM-dd");
        const dataL=d
        const listaNo=lezione.lessonclientunavailable?lezione.lessonclientunavailable.split(","):[]
        if (!(listaNo.includes(dataL.toFormat("yyyyMMdd"))))
        peoplePerDay[key] = (peoplePerDay[key] || 0) + 1;
        d = d.plus({ days: 1 })
      }
    });
    nolFilt.forEach(lezione => {
      const from = DateTime.fromFormat(lezione.rentalfrom, "yyyyMMdd");
      const to = DateTime.fromFormat(lezione.rentalto, "yyyyMMdd");
      let d=from
      while (d <= to) {
        const key = d.toFormat("yyyy-MM-dd");
        const dataL=d
        const listaNo=lezione.rentalcustunavailable?lezione.rentalcustunavailable.split(","):[]
        if (!(listaNo.includes(dataL.toFormat("yyyyMMdd"))))
        peoplePerDay[key] = (peoplePerDay[key] || 0) + 1;
        d = d.plus({ days: 1 })
      }
    });
        setDatiOggi(data)
        const nolMat = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getLinkRentInvs'
      })
        const start2 = oggi;
    const end2 = oggi.plus({ days: 1 })
        const nolFiltMat= nolMat.filter(lezione => {
      if (!lezione.rentinvlinkfrom || !lezione.rentinvlinkto) return false;
      const from = DateTime.fromFormat(lezione.rentinvlinkfrom, "yyyyMMddHHmm");
      const to = DateTime.fromFormat(lezione.rentinvlinkto, "yyyyMMddHHmm");
      return to >= start2 && from <= end2;
    });

    let noleggiOggi=[]
    for (let noleggio of nolFiltMat){
        for (let pacchetto of responseR){
            if (pacchetto.rentalid===noleggio.rentalid){
                if (((pacchetto.rentaltype===1 || pacchetto.rentaltype===2)&& noleggio.inventorytype===1) || ((pacchetto.rentaltype!==1 && pacchetto.rentaltype!==2))) {
                    let priceDay=null
                    let priceOra=null
                    const noleggiTotali=totaleCosti(nolMat.filter(noleggioF=>noleggioF.rentalid===noleggio.rentalid),pacchetto.rentalcustname,pacchetto.rentaltype)

                    if (pacchetto.rentaltype===1 ||  (pacchetto.rentaltype===2 && noleggio.inventorytype===3)){
                        priceDay=70
                        priceOra=50
                    }
                    else if (pacchetto.rentaltype===2 ){
                        priceDay=50
                        priceOra=30
                    }
                    else if (pacchetto.rentaltype===3){
                        priceDay=40
                        priceOra=30
                    }
                    else if (pacchetto.rentaltype===4){
                        priceDay=45
                        priceOra=35
                    }
                    else if (pacchetto.rentaltype===5){
                        priceDay=45
                        priceOra=35
                    }
                    let costoTotale={}
                    let numeroGiorni={}
                    for (let data in noleggiTotali){

                        for (let persona in noleggiTotali[data]){
                            if (!(persona in costoTotale))costoTotale[persona]=0
                            if (!(persona in numeroGiorni))numeroGiorni[persona]=0
                            numeroGiorni[persona]+=1
                            const durata=noleggiTotali[data][persona]
                            if (durata<=1){
                                costoTotale[persona]+=priceOra*durata}
                            else if (durata>1 && durata<=3){
                                costoTotale[persona]+=(priceOra + ((durata) - 1) *10)}
                            else {
                                costoTotale[persona]+=priceDay
                                }
                        }
                    }
                    let prezziFin={}
                    for (let persona in costoTotale){
                        const prezzoGiorni=listinoPrezziNol[pacchetto.rentaltype]["prezzi"][numeroGiorni[persona]]?listinoPrezziNol[pacchetto.rentaltype]["prezzi"][numeroGiorni[persona]]:listinoPrezziNol[pacchetto.rentaltype]["prezzi"][7]*numeroGiorni[persona]
                        prezziFin[persona]=costoTotale[persona]<prezzoGiorni?costoTotale[persona]:prezzoGiorni
                    }
                    let sconto=0
                    let daPagTot=0
                    for (let persona in prezziFin) {
                        daPagTot+=prezziFin[persona]
                    }
                    if (pacchetto.rentaladvance!==0 && pacchetto.rentaladvance!==daPagTot){
                        sconto=(daPagTot-pacchetto.rentaladvance)/daPagTot
                    }
                    const durata=noleggiTotali[DateTime.fromFormat(noleggio.rentinvlinkto.slice(0,8), "yyyyMMdd").toFormat("dd/MM/yyyy")][noleggio.rentalname?noleggio.rentalname:pacchetto.rentalcustname]
                    let costoG=0
                    if (durata<=1){
                        costoG=priceOra*durata}
                    else if (durata>1 && durata<=3){
                        costoG=costoG = priceOra + (priceDay - priceOra) * ((durata - 1) / (3 - 1))}
                    else {
                        costoG=priceDay
                        }
                    guadagni["noleggi"]+=((((DateTime.fromFormat(noleggio.rentinvlinkto, "yyyyMMddHHmm").diff(DateTime.fromFormat(noleggio.rentinvlinkfrom, "yyyyMMddHHmm"))).milliseconds/(3600*1000))/durata))*(costoG*(1-sconto))
                    noleggiOggi.push({
                        rentalid: pacchetto.rentalid,
                        nome: pacchetto.rentalcustname,
                        durata: DateTime.fromFormat(noleggio.rentinvlinkto, "yyyyMMddHHmm").diff(DateTime.fromFormat(noleggio.rentinvlinkfrom, "yyyyMMddHHmm")),
                        materiale: `${noleggio.inventorymeasure} ${noleggio.inventorydescr} ${noleggio.inventorynotes}`,
                        tipo:pacchetto.rentaltype,
                        costo:((((DateTime.fromFormat(noleggio.rentinvlinkto, "yyyyMMddHHmm").diff(DateTime.fromFormat(noleggio.rentinvlinkfrom, "yyyyMMddHHmm"))).milliseconds/(3600*1000))/durata))*(costoG*(1-sconto)),
                        nomeNol:noleggio.rentalname?noleggio.rentalname:pacchetto.rentalcustname
                    })
                }
                break
            }
        }
    }
    dettagli["noleggi"]=noleggiOggi
    dettagli["lezioni"]=[]
            for (let lezione of ore){
        for (let pacchetto of response) {
            if (pacchetto.lessonid===lezione.lessonid) {
                const inizioDate = DateTime.fromFormat(lezione.lessondatestart, "yyyyMMddHHmm")
                const fineDate = DateTime.fromFormat(lezione.lessondateend, "yyyyMMddHHmm")
                for (let utente of utenti) {
                    if (utente.userid === lezione.userid) {
                        for (let periodo of periodi) {
                            const inizioPeriodoDate = DateTime.fromFormat(periodo.workperioddatefrom, "yyyyMMdd")
                            const finePeriodoDate = DateTime.fromFormat(periodo.workperioddateto, "yyyyMMdd")
                            if (periodo.userid === utente.userid && sovrapposti(inizioDate, fineDate, inizioPeriodoDate, finePeriodoDate)) {

                                let importoStip = 0
                                const durata = (convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)) / (3600 * 1000)
                                if (periodo.workperiodfixedsalarycurrency === 0) {
                                    const numero = pacchetto.lessonnumstudents

                                    let paga = numero === 1 ? durata * (periodo.workperiodhourlypayment) : durata * (periodo.workperiodhourlypaymentgroups)
                                    if (utente.type === 5 && pacchetto.lessontype === "Avanzata") {
                                        let commissionLez = 0
                                        if (lezione.inventories.length > 0)
                                            commissionLez = periodo.workperiodcommissionratelessonmaterial / 100
                                        else
                                            commissionLez = periodo.workperiodcommissionratelesson / 100
                                        paga = ((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100)) * commissionLez * durata) / pacchetto.lessonpacket
                                    }
                                    importoStip = paga
                                } else {
                                    importoStip = (((convertDate(lezione.lessondateend) - convertDate(lezione.lessondatestart)) / (60 * 60 * 1000)) * (pacchetto.lessonnumstudents === 1 ? periodo.workperiodhourlypayment : periodo.workperiodhourlypaymentgroups)) / datiCambi[convertDate(lezione.lessondateend).toFormat("yyyyMMdd")]
                                }
                                guadagni["lezioni"]+=(((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))/pacchetto.lessonpacket)*durata)-importoStip
                                dettagli["lezioni"].push({istruttore:lezione.userid,studente:pacchetto.lessonstudentname,durata:durata,commissione:importoStip,guadagno:(((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))/pacchetto.lessonpacket)*durata)-importoStip,inizio:inizioDate,fine:fineDate})

                            }

                        }
                    }
                }
            }
        }
    }
    dettagli["storage"]=[]
    for (let storage of responseS){
        const inizioS=DateTime.fromFormat(storage.storagefrom,"yyyyMMdd")
        const fineS=DateTime.fromFormat(storage.storageto,"yyyyMMdd")
        const dataL=DateTime.fromJSDate(selectedDate)
        if (sovrapposti(dataL,dataL.plus({days:1}),inizioS,fineS)){
            const durata=fineS.startOf('day').diff(inizioS.startOf('day'), 'days').days
            const costoG=(storage.storagecost * (1 - (storage.storagediscount || 0) / 100))/durata
            guadagni["storage"]+=costoG
            dettagli["storage"].push(storage)
        }
    }
    dettagli["maglie"]=[]
    for (let maglia of accessori){
        const dataL=DateTime.fromJSDate(selectedDate)
        if (maglia.accessorysold===1 && sovrapposti(dataL,dataL.plus({days:1}),DateTime.fromFormat(maglia.accessorysolddate,"yyyyMMdd"),DateTime.fromFormat(maglia.accessorysolddate,"yyyyMMdd"))){
            if (maglia.accessorysoldcurrency===0){
                guadagni["maglie"]+=maglia.accessorysoldprice
            }
            else if (maglia.accessorysoldcurrency===1){
                guadagni["maglie"]+=maglia.accessorysoldprice/datiCambi[maglia.accessorysolddate]
            }
            dettagli["maglie"].push(maglia)

        }
    }
    dettagli["riparazioni"]=[]
    for (let riparazione of riparazioni){
        const dataL=DateTime.fromJSDate(selectedDate)
        if ( sovrapposti(dataL,dataL.plus({days:1}),DateTime.fromFormat(riparazione.repairdate,"yyyyMMdd"),DateTime.fromFormat(riparazione.repairdate,"yyyyMMdd"))){
            if (riparazione.repaircostcurrency===0){
                guadagni["riparazioni"]+=riparazione.repaircost
            }
            else if (riparazione.repaircostcurrency===1){
                guadagni["riparazioni"]+=riparazione.repaircost/datiCambi[riparazione.accessorysolddate]
            }
            dettagli["riparazioni"].push(riparazione)

        }
    }
    dettagli["escursioni"]=[]
    for (let escursione of escursioni){
        const dataL=DateTime.fromJSDate(selectedDate)
        if (escursione.excursiondatestart===dataL.toFormat("yyyyMMdd")) {
            const guadagniEsc = guadagnoEscursione({
                escursione: escursione,
                spese: costiEsc.filter(spesa => spesa.excursionid === escursione.excursionid),
                partecipanti: clientiEsc.filter(spesa => spesa.excursionid === escursione.excursionid),
                cambio: datiCambi
            })
            guadagni["escursioni"] += (guadagniEsc[0] - guadagniEsc[1])
            dettagli["escursioni"].push(escursione)
        }

    }
        $("#totaleNettoBox").html(`
          <div style="
            font-size: 40px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 20px;
          ">€ ${ (Object.values(guadagni)
  .reduce((acc, val) => acc + val, 0)).toFixed(2)}
          </div>
        `);
        const dataChart = Object.entries(guadagni)
          .filter(([_, value]) => value > 0)
          .map(([key, value]) => ({
            categoria: key,
            valore: Number(value.toFixed(2))
          }));
        $("#infoDettagli").dxPopup({
    width: "90%",
    height: '90%',
    visible: false,
    dragEnabled: true,
    hideOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const popupHeight = e.component.option("height");
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%;"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    })}});
        $("#chartPieGuadagni").dxPieChart({
  type: "doughnut",
  palette: "Soft Pastel",
  dataSource: dataChart,
  series: [{
    argumentField: "categoria",
    valueField: "valore",
    label: {
      visible: true,
      format: {
        type: "fixedPoint",
        precision: 0
      },
      connector: {
        visible: true
      }
    }
  }],
            onPointClick:function(e){
  e.component.hideTooltip();
  apriPopupDettagli(e.target.argument)
  },
  tooltip: {
    enabled: true,
    customizeTooltip: function (pointInfo) {
      return {
        html: `
          <div style="padding: 5px; font-size: 14px;">
            <b>Categoria:</b> ${pointInfo.argument}<br>
            <b>Valore:</b> ${pointInfo.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} € <br>
            <b>Percentuale:</b> ${pointInfo.percentText}
          </div>
        `,
      };}
  },
  legend: {
    horizontalAlignment: "center",
    verticalAlignment: "bottom"
  }
});
        setLoading(false);
    }

    fetchData();
  },[selectedDate])
  function handleClick(item,confermate) {
      const appuntamenti=appOggi[item.categoria]
      const divGen=document.createElement("div")
      let lunghezza=false
        if (appuntamenti.length){
            const divConf=document.createElement("div")
            const titolo1=document.createElement("h3")
            titolo1.innerText=`${item.categoria}`
            titolo1.style.fontFamily = "Poppins, sans-serif";
            titolo1.style.marginBottom="0px"
            divConf.appendChild(titolo1)
            const divTab=document.createElement("div")
            divTab.id="gridContainerConf"
            divConf.appendChild(divTab)
            divGen.appendChild(divConf)
        }
        else {
        const titolo1=document.createElement("h3")
            titolo1.innerText=`Non ci sono ${item.categoria}`
            titolo1.style.fontFamily = "Poppins, sans-serif";
            titolo1.style.marginBottom="0px"
            divGen.appendChild(titolo1)
        }

      let colonne=[]
      let formattedRows=[]
      if (item.categoria==="Lezioni"){
        for (let lezione of appOggi["Lezioni"]){

            if (confermate===2 ||(lezione.lessonconfirmed===confermate ))

                formattedRows.push({"nome":lezione.lessonstudentname,"arrivo":convertDate(lezione.lessonclientarrival).toISO({ includeOffset: false }),"partenza":convertDate(lezione.lessonclientdeparture).toISO({ includeOffset: false }),
                "pacchetto":lezione.lessonpacket, "oreFatte":lezione.lessonhours,"confermata":lezione.lessonconfirmed,
                })
        }
        colonne=[
            {dataField:"confermata", caption:"Confermata",groupIndex: 0, alignment:"center",
            customizeText:function(e){
                if (e.value) return "Si"
                else return "No"
            }
            },
            {dataField:"nome", caption:"Nome", hidingPriority:5,alignment:"center",},
            {dataField:"pacchetto", caption:"Pacchetto",hidingPriority:1, alignment:"center",
              customizeText:function(e){
                return `${e.value}H`
              }
            },
            {dataField:"oreFatte", caption:"Ore concluse",hidingPriority:3, alignment:"center",
            customizeText:function(e){
                return `${e.value}H`
              }
            },
            {dataField:"arrivo", caption:"Arrivo", hidingPriority:2,alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},
            {dataField:"partenza", caption:"Partenza", hidingPriority:4,alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},


        ]
      }
      else if (item.categoria==="Noleggi"){
        for (let noleggio of appOggi["Noleggi"]){
            if (confermate===2 ||(noleggio.rentalconfirmed===confermate))
                formattedRows.push({"nome":noleggio.rentalcustname,"arrivo":convertDate(noleggio.rentalfrom).toISO({ includeOffset: false }),"partenza":convertDate(noleggio.rentalto).toISO({ includeOffset: false }),
                "tipo":noleggio.rentaltype,"confermata":noleggio.rentalconfirmed,
                })
        }
        colonne=[
        {dataField:"confermata", caption:"Confermata",groupIndex: 0, alignment:"center",
            customizeText:function(e){
                if (e.value) return "Si"
                else return "No"
            }
            },
            {dataField:"nome", caption:"Nome", alignment:"center",hidingPriority:4,},
            {dataField:"tipo", caption:"Tipo Noleggio", hidingPriority:1,alignment:"center",
              customizeText:function(e){
                return convertiIdNoleggio(e.value)
              }
            },
            {dataField:"arrivo", caption:"Arrivo",hidingPriority:2, alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},
            {dataField:"partenza", caption:"Partenza",hidingPriority:3, alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},
        ]
      }
      else if (item.categoria==="Storage"){
        for (let storage of appOggi["Storage"]){
            if (confermate===2 ||(storage.storageconfirmed===confermate))
                formattedRows.push({"nome":storage.storagecustname,"arrivo":convertDate(storage.storagefrom).toISO({ includeOffset: false }),"partenza":convertDate(storage.storageto).toISO({ includeOffset: false }),
                "tipo":storage.storagetype,"confermata":storage.storageconfirmed,
                })
        }
        colonne=[
        {dataField:"confermata", caption:"Confermata",groupIndex: 0, alignment:"center",
            customizeText:function(e){
                if (e.value) return "Si"
                else return "No"
            }
            },
            {dataField:"nome", caption:"Nome", alignment:"center",hidingPriority:4,},
            {dataField:"tipo", caption:"Tipo Storage", hidingPriority:1,alignment:"center",
              customizeText:function(e){
                return convertiTipoStorage(e.value)
              }
            },
            {dataField:"arrivo", caption:"Arrivo",hidingPriority:2, alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},
            {dataField:"partenza", caption:"Partenza",hidingPriority:3, alignment:"center",
            customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }},
        ]
      }
      setTimeout(()=>{
      $("#gridContainerConf").dxDataGrid({
        dataSource:formattedRows,
        columns:colonne,
        showBorders: false,
        columnAutoWidth: true,
        columnHidingEnabled: true,
  grouping: {
    autoExpandAll: true // se true espande tutti i gruppi di default
  }
      })
      },0)
      $("#infoPopup").dxPopup("instance").option("contentTemplate", () => divGen);
      $("#infoPopup").dxPopup("instance").option( "title",`Dettagli ${item.categoria} del ${DateTime.fromJSDate(selectedDate).toFormat("dd/MM/yyyy")}`);
      $("#infoPopup").dxPopup("instance").show()
  }

  return (
    <div style={{ width: "100%"}}>

        <div style={{display:"flex",justifyContent: "space-between",}}>
            <h1 style={{margin:"0px",fontSize:"30px"}}>Benvenuto</h1>
            <div id="dateboxRef"/>
        </div>
        <div id="infoPopup"/>
      <h2>Panoramica giornaliera</h2>
        <div style={{display:"flex",justifyContent: "space-between",}}>
            <div style={{display:"flex",flexDirection: "column",alignItems: "center", gap: "1px",flex: 1 }}>
                <h2>Guadagno netto:</h2>
                <div id="totaleNettoBox"></div>
            </div>
        <div id="chartPieGuadagni" style={{minHeight:"300px",flex: 3}}></div>
            </div>
      <div
        style={{
          display: "flex",
          gap: "15px",
          width: "100%",
          boxSizing: "border-box",
          flexWrap: "wrap",
        }}
      >
        {datiOggi.map((item, index) => (
  <div
    key={index}
    onClick={() => item && handleClick(item,2)} // solo se i dati sono pronti
    style={{
      flex: 1,
      padding: isMobile ? "20px 0" : "20px",
      textAlign: "center",
      borderRadius: "15px",
      background: "linear-gradient(135deg, #00c6ff, #0072ff)",
      color: "#fff",
      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
      transition: "transform 0.2s, box-shadow 0.2s, background 0.3s",
      cursor: !loading ? "pointer" : "default",
    }}
    onMouseEnter={(e) => {
      if(!loading){
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 12px 25px rgba(0,0,0,0.25)";
      }
    }}
    onMouseLeave={(e) => {
      if(!loading){
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
      }
    }}
  >
    <FontAwesomeIcon icon={(!loading) ? item.icon : faUser} size="2x" style={{ marginBottom: "10px" }} />
    <h3 style={{ margin: "10px 0" }}>{(!loading) ? item.categoria : "Caricamento..."}</h3>

    {!loading ? (
      <>
        <div style={{ fontSize: "28px", fontWeight: 700, margin: "8px 0" }}>
          {item.confermate + item.nonConfermate}
        </div>
        <div onClick={(e) => { e.stopPropagation(); handleClick(item,1) }}>
          <FontAwesomeIcon icon={faCheck} /> {` ${item.confermate}`}{!isMobile && ` confermate`}
        </div>
        <div onClick={(e) => { e.stopPropagation(); handleClick(item,0) }}>
          <FontAwesomeIcon icon={faTriangleExclamation} /> {` ${item.nonConfermate}`}{!isMobile && ` non confermate`}
        </div>
      </>
    ) : (
      <div style={{ fontSize: "16px", fontStyle: "italic", marginTop: "20px" }}>
        Caricamento...
      </div>
    )}
  </div>
))}

      </div>
      <div
  style={{
    display: "flex",
    gap: "15px",
    width: "100%",
    padding:"20px 0px 20px 0px",
    boxSizing: "border-box",
    flexWrap: "wrap",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "flex-start",
  }}
>
  <div style={{ flex: 1, minWidth: "270px" }}>
    <div id="gridContainerAll"/>
  </div>

  <div style={{ flex: 1, minWidth: "350px" }}>
    <div id="schedulerArrivi" className="agendaSchedulerArrivi"/>
  </div>
</div>
<div id="gridContainerOre"/>
        <div id="gridContainerNoleggi"></div>
        <div id="infoDettagli"></div>
    </div>
  );
}
